import { HttpParams } from "@angular/common/http";
import { AppConstants } from "../../common/constants/app-constants";
import { CarStatus, CarBusinessLine } from "../constants/car-basic-data";


export class CarCriteria {
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  
  offerIds : string[] = [];
  carIds : string[] = [];
  sellerIds : string[] = [];
  
  makes : string[] = [];
  models : string[] = [];
  versions : string[] = [];
  features: string[] = [];

  gearBoxes : string[] = [];
  fuels : string[] = [];

  countries : string[] = [];
  cities : string[] = [];

  priceMin : number = AppConstants.CAR_PRICE.SALE.MIN;
  priceMax : number = AppConstants.CAR_PRICE.SALE.MAX;

  yearMin : number = AppConstants.CAR_YEAR_MIN;
  yearMax : number = new Date().getFullYear();

  startDate  = "";
  endDate = "" ;

  statuses: CarStatus[] = [];

  businessLine? : CarBusinessLine = CarBusinessLine.BUY;

  public getHttpParams(): HttpParams {
    
    return new HttpParams()
                .append('pageNumber', this.pageNumber)
                .append('pageSize', this.pageSize)

                .append('offerIds', this.offerIds.join(', '))
                .append('carIds', this.carIds.join(', '))
                .append('sellerIds', this.sellerIds.join(', '))

                .append('statuses', this.statuses.join(', '))

                .append('makes', this.makes.join(', '))
                .append('models', this.models.join(', '))
                .append('versions', this.versions.join(', '))
                .append('features', this.features.join(', '))

                .append('gearBoxes', this.gearBoxes.join(', '))
                .append('fuels', this.fuels.join(', '))

                .append('countries', this.countries.join(', '))
                .append('cities', this.cities.join(', '))

                .append('priceMin', this.priceMin)
                .append('priceMax', this.priceMax)

                .append('yearMin', this.yearMin)
                .append('yearMax', this.yearMax)

                .append('startDate', this.startDate)
                .append('endDate', this.endDate);

                //.append('businessLines', this.businessLines.join(', '));
    
  }
}